/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { displayModal } from '@insticator/insticator-ui'; // iui-state
import { resetForm } from '@insticator/insticator-ui';
import { addUser, addUserToTable } from 'state/actions/accountState/account_data';
// component
import AddUser from 'pages/dashboard/account/users/adduser/adduser';



/* ========== ~~~~~~~~~~ ACCOUNT ADD USER : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData, sessionStatus }) => ({
    fields: accountData.addUser.fields,
    savingData: accountData.addUser.savingData,
    editable: true,
    hasStoredData: false,
    accountUUID: sessionStatus.accountUUID
});

// map actions
const mapDispatchToProps = dispatch => ({
    addUser: (fields, data, accountUUID, successAction, failAction) => dispatch(addUser(fields, data, accountUUID, successAction, failAction)),
    addUserToTable: (response) => dispatch(addUserToTable(response)),
    resetForm: formName => dispatch(resetForm(formName)),
    displayModal: bool => dispatch(displayModal(bool))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddUser);
